import { FormSelectField, SelectProps } from 'omakase';
import PhoneCountryCodes from '@tock/shared/constants/PhoneCountryCodes';
import React from 'react';

type FormPhoneCountryCodeFieldOwnProps = { phoneFieldName?: string; children?: React.ReactNode };

type FormPhoneCountryCodeFieldProps = FormPhoneCountryCodeFieldOwnProps &
  Omit<SelectProps, 'children'>;

/**
 * Formik-ready select field that includes all ISO phone country codes as options
 */
const FormPhoneCountryCodeField: React.FunctionComponent<FormPhoneCountryCodeFieldProps> = ({
  name = 'phoneCountryCode',
  id = 'phoneCountryCode',
  phoneFieldName = 'phone',
  label = 'Phone country code',
  placeholder = 'Select a country code',
  onChange,
  ...rest
}) => {
  return (
    <FormSelectField
      name={name}
      id={id}
      label={label}
      onChange={onChange}
      placeholder={placeholder}
      inputProps={{
        'data-testid': 'phone-country-code',
        autoComplete: 'tel-country-code',
      }}
      {...rest}
    >
      {PhoneCountryCodes.map(({ phone, iso, name }) => (
        <option key={`${phone} ${iso}`} value={`${phone} ${iso}`}>
          {name}&nbsp;{phone}
        </option>
      ))}
    </FormSelectField>
  );
};

export default FormPhoneCountryCodeField;
